import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import Logo from "./Logo";

const links = [
  { label: "Locals order", href: "#popular" },
  { label: "Local spots", href: "#exclusive" },
  { label: "How it works", href: "#how" },
  { label: "Why My Local", href: "#why" },
  { label: "Partner", href: "/partner" },
  { label: "Download", href: "#download" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled ? "backdrop-blur-xl bg-white/80 border-b border-zinc-200/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <Logo size="md" withText={false} />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://www.mylocalapp.shop/"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-order-btn"
            className="text-sm font-semibold px-5 py-2.5 rounded-full bg-zinc-900 text-white hover:bg-zinc-800 transition-colors"
          >
            Order local
          </a>
        </div>

        <button
          data-testid="nav-menu-toggle"
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-zinc-200 bg-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} weight="bold" /> : <List size={18} weight="bold" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-zinc-200/60 bg-white/95 backdrop-blur-xl"
        >
          <div className="px-6 py-5 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.href.replace("#", "")}`}
                className="text-base text-zinc-800 py-1.5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://www.mylocalapp.shop/"
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-order-btn"
              className="mt-2 text-center text-sm font-semibold px-5 py-3 rounded-full bg-zinc-900 text-white"
            >
              Order local
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
